module.exports = __webpack_public_path__ + "img/triangle-right-filled.e0cf5ee3.svg";